import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import { newGetAllCategories } from "@/services/api/newListingApis";

export const useNewGetAllCategories = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.NEWGETALLCATEGORIES],
    queryFn: async () => newGetAllCategories(),
  });
};